export default __webpack_public_path__ + "static/favicon-75e9b3300e0b4d713e3fd78b853e4baf.ico";